/* eslint-disable max-len */
import React, { Fragment } from 'react'
import TableBody from './TableBody'
import { useOnClickOutside } from '../../../../CommonMethods/OutsideClick';
import { useState,useRef } from 'react';
import { useSearchParams } from 'react-router-dom';

const ManageDashboardTable=({pageNumber,List,handleDelete,setConfirmationState,setTextAreaMsg,setSelectedRow, loading,isPatient,setIsAnyFieldFilled,sortValue,setisSortSelected,handleSearchParams})=>{
    const [selectedIndex, setSelectedIndex] = useState(null); 
    const selectedRef = useRef();
    const urlParams = new URLSearchParams(window.location.search);
    const branchUrl = urlParams.get('sort');

    useOnClickOutside(selectedRef, () => {
        setSelectedIndex(null)
    });
    const handleSort = (key) => {
        setisSortSelected(true)
        if(sortValue === '') handleSearchParams('sort', `${key}+asc`)
        else {
            if(sortValue.includes(key)) handleSearchParams('sort', `${key}+${sortValue.includes('+desc') ? 'asc' : 'desc'}`)
            else handleSearchParams('sort', `${key}+asc`)
        }
    }

    return(
        <div className={`h-[calc(100vh-215px)] overflow-auto scrollbar_purple pb-2.5`}>
            <table aria-label="Outside Table" className="w-full table-auto">
                <thead>
                    <tr className="h-[38px] w-full bg-[#EDD7E1] rounded-sm sticky top-0 left-0 z-[1]">
                        <th id="timestamp" className="px-[18px] py-2 min-w-[194px] rounded-tl-sm rounded-bl-sm" onClick={() => {handleSort('measurement_date_time')}}>
                            <span className="flex items-center justify-start text-sm font-normal text-[#000000]">Timestamp
                                <button  className="pl-2.5 sortedIcon"><img loading="lazy" decoding="async" src={branchUrl !== undefined && branchUrl?.split("+")[0] === "measurement_date_time" ?`/images/column-sorting_desc.svg`:'/images/column-sorting.svg'} alt="icon" /></button>
                            </span>
                        </th>
                        <th id="reading_type" className="px-[18px] py-2 xl:min-w-[160px] min-w-[180px] rounded-tl-sm rounded-bl-sm" onClick={() => {handleSort('reading_type')}}>
                            <span className="flex items-center justify-start text-sm font-normal text-[#000000]">Reading Type
                                <button  className="pl-2.5 sortedIcon"><img loading="lazy" decoding="async" src={branchUrl !== undefined && branchUrl?.split("+")[0] === "reading_type" ?`/images/column-sorting_desc.svg`:'/images/column-sorting.svg'} alt="icon" /></button>
                            </span>
                        </th>
                        <th id="alert_type" className="px-[18px] py-2 min-w-[170px]">
                            <span className="flex items-center justify-start text-sm font-normal text-[#000000]" onClick={() => {handleSort('alert_type')}}>Alert Type
                                <button  className="pl-2.5 sortedIcon"><img loading="lazy" decoding="async" src={branchUrl !== undefined && branchUrl?.split("+")[0] === "alert_type" ?`/images/column-sorting_desc.svg`:'/images/column-sorting.svg'} alt="icon" /></button>
                            </span>
                        </th>
                        <th id="reading_details" className="px-[18px] py-2 min-w-[200px]" onClick={() => {handleSort('reading_details')}}>
                            <span className="flex items-center justify-start text-sm font-normal text-[#000000]">Reading Details
                                <button  className="pl-2.5 sortedIcon"><img loading="lazy" decoding="async" src={branchUrl !== undefined && branchUrl?.split("+")[0] === "reading_details" ?`/images/column-sorting_desc.svg`:'/images/column-sorting.svg'} alt="icon" /></button>
                            </span>
                        </th>
                        <th id="patient_name" className="px-[18px] py-2 min-w-[160px]" onClick={() => {handleSort('last_name')}}>
                            <span className="flex items-center text-sm font-normal text-[#000000]">Patient Name
                                <button  className="pl-2.5 sortedIcon"><img loading="lazy" decoding="async" src={branchUrl !== undefined && branchUrl?.split("+")[0] === "last_name" ?`/images/column-sorting_desc.svg`:'/images/column-sorting.svg'} alt="icon" /></button>
                            </span>
                        </th>
                        <th className="px-[18px] py-2 min-w-[120px] text-start">
                            <span className="flex items-center justify-start text-sm font-normal text-[#000000]">Readings Days
                            </span>
                        </th>
                        <th className="px-[18px] py-2 min-w-[120px] text-start">
                            <span className="flex items-center justify-start text-sm font-normal text-[#000000]">Qualified Contacts

                            </span>
                        </th>
                        <th className="px-[18px] py-2 min-w-[120px] text-start">
                            <span className="flex items-center justify-start text-sm font-normal text-[#000000]">Contact Deadline
                            </span>
                        </th>
                        <th className="px-[18px] py-2 min-w-[120px] text-start">
                            <span className="flex items-center justify-start text-sm font-normal text-[#000000]">Reading Deadline</span>
                        </th>
                        <th id="device_id" className="px-[18px] py-2 min-w-[150px]" onClick={() => {handleSort('device_id')}}>
                            <span className="flex items-center justify-start text-sm font-normal text-[#000000]">Device ID
                                <button  className="pl-2.5 sortedIcon"><img loading="lazy" decoding="async" src={branchUrl !== undefined && branchUrl?.split("+")[0] === "device_id" ?`/images/column-sorting_desc.svg`:'/images/column-sorting.svg'} alt="icon" /></button>
                            </span>
                        </th>
                        <th id="user_name_sort" className="px-[18px] py-2 min-w-[170px]" onClick={() => {handleSort('user_name')}}>
                            <span className="flex items-center justify-start text-sm font-normal text-[#000000]">Username
                                <button  className="pl-2.5 sortedIcon"><img loading="lazy" decoding="async" src={branchUrl !== undefined && branchUrl?.split("+")[0] === "user_name" ?`/images/column-sorting_desc.svg`:'/images/column-sorting.svg'} alt="icon" /></button>
                            </span>
                        </th>
                        <th id="name_id" className="px-[18px] py-2 min-w-[146px]" onClick={() => {handleSort('patient_id')}}>
                            <span className="flex items-center justify-start text-sm font-normal text-[#000000]">ID
                                <button  className="pl-2.5 sortedIcon"><img loading="lazy" decoding="async" src={branchUrl !== undefined && branchUrl?.split("+")[0] === "patient_id" ?`/images/column-sorting_desc.svg`:'/images/column-sorting.svg'} alt="icon" /></button>
                            </span>
                        </th>
                        <th className="px-[18px] py-2 rounded-tr-[2px] rounded-br-[2px] sticky top-0 right-[-1px] bg-[#EDD7E1] min-w-[70px]">
                            <span className="flex items-center justify-center text-sm font-normal text-[#000000]">Action
                            </span>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {List?.data?.map((item,index)=>(
                        <Fragment key={item._id}>
                            <TableBody
                                tableData={item}
                                List={List}
                                indexNum={index}
                                isPatient={isPatient}
                                pageNumber={pageNumber}
                                selectedIndex={selectedIndex}
                                setSelectedIndex={setSelectedIndex}
                                selectedRef={selectedRef}
                                lastIndex={List?.data?.length}
                                setConfirmationState={setConfirmationState}
                                setTextAreaMsg={setTextAreaMsg}
                                setSelectedRow={setSelectedRow}
                                handleDelete={handleDelete}
                                loading={loading}
                                setIsAnyFieldFilled={setIsAnyFieldFilled}
                            />
                        </Fragment>
                    ))}
                </tbody>
            </table>
        </div>
    )
}

export default ManageDashboardTable